// extracted by mini-css-extract-plugin
export default {"statusWrapper":"selectedRaceStatus_statusWrapper__zGuTa"};